const plural = (count: number, singular: string, pluralForm: string) =>
  `${count} ${count === 1 ? singular : pluralForm}`;

export const feedbackText = {
  title: 'Feedback',
  newFeedback: 'New feedback',
  createTitle: 'New feedback',
  allFeedback: 'All feedback',
  emptyTitle: 'No feedback questions yet',
  emptySubtitle: 'Ask your learners a quick question after they finish reels',
  searchEmptyTitle: 'Nothing found',
  searchEmptySubtitle: 'No feedback matches your search',
  open: 'Open',
  delete: 'Delete',
  deleteConfirm:
    'Delete this feedback? Learners stop seeing it. Answers already given are kept.',
  feedbackCreated: 'Feedback created',
  feedbackDeleted: 'Feedback deleted',
  noEditHint:
    "Feedback can't be edited after it's created. To make changes, delete it and create new feedback. Learners may be asked to respond to the new feedback again.",
  editorTitle: 'Feedback',
  editorSubtitle: 'Collect feedback from learners as they move through reels.',
  titleLabel: 'Title',
  titlePlaceholder: 'Quick check-in',
  questionLabel: 'Question',
  questionPlaceholder: 'How useful have the microreels been so far?',
  answersLabel: 'Answers',
  answersHint: 'Learners pick one. Add between 2 and 4 answers.',
  answerPlaceholder: 'Answer text',
  addAnswer: 'Add answer',
  maxAnswersHint: (max: number) => `A question can have up to ${max} answers`,
  deleteAnswer: 'Delete answer',
  duplicateAnswersWarning: 'Answers must be unique — edit the repeated ones',
  answersSummary: (count: number) =>
    `${plural(count, 'answer', 'answers')} · learners pick one`,
  answersCount: (count: number) => plural(count, 'answer', 'answers'),
  cancel: 'Cancel',
  publish: 'Publish',
  publishConfirmTitle: 'Publish feedback?',
  publishConfirmText:
    'This will make the feedback question available to all learners in this workspace.',
  createFeedback: 'Publish feedback',
  creating: 'Publishing...',
  deliveryTitle: 'Delivery',
  showAfterLabel: 'Appears after',
  showAfterOption: (count: number) =>
    `After ${plural(count, 'watched reel', 'watched reels')}`,
  showAfterValue: (count: number) =>
    plural(count, 'watched reel', 'watched reels'),
  showAfterCaption: (count: number) =>
    `Appears after ${plural(count, 'watched reel', 'watched reels')}`,
  showAfterChip: (count: number) =>
    `After ${plural(count, 'watched reel', 'watched reels')}`,
  createdAgo: (timeAgo: string) => `Created ${timeAgo}`,
  createdLabel: 'Created',
  responsesCount: (count: number) => plural(count, 'response', 'responses'),
  answerShare: (share: string, count: number) => `${share}% (${count})`,
  phoneSelectHint: 'Select one',
  phoneNotNow: 'Not now',
  phoneSubmit: 'Submit',
};
